'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDataTable = exports.DataTableCell = exports.DataTableHeadCell = exports.DataTableRow = exports.DataTableBody = exports.DataTableHead = exports.DataTableContent = exports.DataTable = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _base = require('@rmwc/base');

var _icon = require('@rmwc/icon');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @extends React.Component */

/** The DataTable Component. */


var DataTable = exports.DataTable = function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'classNames', {
      enumerable: true,
      writable: true,
      value: function value(props) {
        return ['rmwc-data-table', {
          'rmwc-data-table--sticky-columns': !!props.stickyColumns,
          'rmwc-data-table--sticky-columns-1': !!props.stickyColumns,
          'rmwc-data-table--sticky-rows': !!props.stickyRows,
          'rmwc-data-table--sticky-rows-1': !!props.stickyRows
        }];
      }
    }), Object.defineProperty(_this, 'consumeProps', {
      enumerable: true,
      writable: true,
      value: ['stickyColumns', 'stickyRows']
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  return DataTable;
}(_base.Component);
/** @extends React.Component */

/** The data table content. */


Object.defineProperty(DataTable, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'DataTable'
});

var DataTableContent = exports.DataTableContent = function (_Component2) {
  _inherits(DataTableContent, _Component2);

  function DataTableContent() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, DataTableContent);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = DataTableContent.__proto__ || Object.getPrototypeOf(DataTableContent)).call.apply(_ref2, [this].concat(args))), _this2), Object.defineProperty(_this2, 'tag', {
      enumerable: true,
      writable: true,
      value: 'table'
    }), Object.defineProperty(_this2, 'classNames', {
      enumerable: true,
      writable: true,
      value: ['rmwc-data-table__content']
    }), _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  return DataTableContent;
}(_base.Component);
/** @extends React.Component */

/** A header for the data table. */


Object.defineProperty(DataTableContent, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'DataTableContent'
});

var DataTableHead = exports.DataTableHead = function (_Component3) {
  _inherits(DataTableHead, _Component3);

  function DataTableHead() {
    var _ref3;

    var _temp3, _this3, _ret3;

    _classCallCheck(this, DataTableHead);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = DataTableHead.__proto__ || Object.getPrototypeOf(DataTableHead)).call.apply(_ref3, [this].concat(args))), _this3), Object.defineProperty(_this3, 'tag', {
      enumerable: true,
      writable: true,
      value: 'thead'
    }), Object.defineProperty(_this3, 'classNames', {
      enumerable: true,
      writable: true,
      value: ['rmwc-data-table__head']
    }), _temp3), _possibleConstructorReturn(_this3, _ret3);
  }

  return DataTableHead;
}(_base.Component);
/** @extends React.Component */

/** A body for the data table. */


Object.defineProperty(DataTableHead, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'DataTableHead'
});

var DataTableBody = exports.DataTableBody = function (_Component4) {
  _inherits(DataTableBody, _Component4);

  function DataTableBody() {
    var _ref4;

    var _temp4, _this4, _ret4;

    _classCallCheck(this, DataTableBody);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this4 = _possibleConstructorReturn(this, (_ref4 = DataTableBody.__proto__ || Object.getPrototypeOf(DataTableBody)).call.apply(_ref4, [this].concat(args))), _this4), Object.defineProperty(_this4, 'tag', {
      enumerable: true,
      writable: true,
      value: 'tbody'
    }), Object.defineProperty(_this4, 'classNames', {
      enumerable: true,
      writable: true,
      value: ['rmwc-data-table__body']
    }), _temp4), _possibleConstructorReturn(_this4, _ret4);
  }

  return DataTableBody;
}(_base.Component);

Object.defineProperty(DataTableBody, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'DataTableBody'
});
/** @extends React.Component */

/** A row for the data table. */

var DataTableRow = exports.DataTableRow = function (_Component5) {
  _inherits(DataTableRow, _Component5);

  function DataTableRow() {
    var _ref5;

    var _temp5, _this5, _ret5;

    _classCallCheck(this, DataTableRow);

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _ret5 = (_temp5 = (_this5 = _possibleConstructorReturn(this, (_ref5 = DataTableRow.__proto__ || Object.getPrototypeOf(DataTableRow)).call.apply(_ref5, [this].concat(args))), _this5), Object.defineProperty(_this5, 'tag', {
      enumerable: true,
      writable: true,
      value: 'tr'
    }), Object.defineProperty(_this5, 'classNames', {
      enumerable: true,
      writable: true,
      value: function value(props) {
        return ['rmwc-data-table__row', {
          'rmwc-data-table__row--selected': props.selected,
          'rmwc-data-table__row--activated': props.activated
        }];
      }
    }), Object.defineProperty(_this5, 'consumeProps', {
      enumerable: true,
      writable: true,
      value: ['activated', 'selected']
    }), _temp5), _possibleConstructorReturn(_this5, _ret5);
  }

  return DataTableRow;
}(_base.Component);

Object.defineProperty(DataTableRow, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'DataTableRow'
});

var DataTableSortIcon = function DataTableSortIcon() {
  return React.createElement(_icon.Icon, {
    className: 'rmwc-data-table__sort-icon',
    icon: React.createElement('svg', {
      width: '18',
      height: '18',
      viewBox: '0 0 24 24'
    }, React.createElement('path', {
      fill: 'currentColor',
      d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z'
    }))
  });
};

var DataTableHeadCellRoot = function (_Component6) {
  _inherits(DataTableHeadCellRoot, _Component6);

  function DataTableHeadCellRoot() {
    var _ref6;

    var _temp6, _this6, _ret6;

    _classCallCheck(this, DataTableHeadCellRoot);

    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _ret6 = (_temp6 = (_this6 = _possibleConstructorReturn(this, (_ref6 = DataTableHeadCellRoot.__proto__ || Object.getPrototypeOf(DataTableHeadCellRoot)).call.apply(_ref6, [this].concat(args))), _this6), Object.defineProperty(_this6, 'tag', {
      enumerable: true,
      writable: true,
      value: 'th'
    }), Object.defineProperty(_this6, 'classNames', {
      enumerable: true,
      writable: true,
      value: function value(props) {
        return ['rmwc-data-table__cell', 'rmwc-data-table__head-cell', {
          'rmwc-data-table__head-cell--sortable': props.sort !== undefined,
          'rmwc-data-table__head-cell--sorted': !!props.sort,
          'rmwc-data-table__head-cell--sorted-ascending': props.sort === 1,
          'rmwc-data-table__head-cell--sorted-descending': props.sort === -1,
          'rmwc-data-table__cell--align-start': props.alignStart,
          'rmwc-data-table__cell--align-middle': props.alignMiddle,
          'rmwc-data-table__cell--align-end': props.alignEnd
        }];
      }
    }), Object.defineProperty(_this6, 'consumeProps', {
      enumerable: true,
      writable: true,
      value: ['alignStart', 'alignMiddle', 'alignEnd', 'sort', 'onSortChange']
    }), _temp6), _possibleConstructorReturn(_this6, _ret6);
  }

  return DataTableHeadCellRoot;
}(_base.Component);
/** A header cell for the data table. */


Object.defineProperty(DataTableHeadCellRoot, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'DataTableHeadCellRoot'
});

var DataTableHeadCell = exports.DataTableHeadCell = function DataTableHeadCell(props) {
  var onClickProp = props.onSortChange && props.sort !== undefined ? {
    onClick: function onClick(evt) {
      props.onSortChange && props.onSortChange(props.sort === null ? 1 : props.sort === 1 ? -1 : null); //$FlowFixMe

      props['onClick'] && props['onClick'](evt);
    }
  } : {};
  return React.createElement(DataTableHeadCellRoot, Object.assign({}, props, onClickProp), props.sort !== undefined && React.createElement(DataTableSortIcon, null), props.children);
};

DataTableHeadCell.displayName = 'DataTableHeadCell';
/** @extends React.Component */

/** A cell for the DataTable */

var DataTableCell = exports.DataTableCell = function (_Component7) {
  _inherits(DataTableCell, _Component7);

  function DataTableCell() {
    var _ref7;

    var _temp7, _this7, _ret7;

    _classCallCheck(this, DataTableCell);

    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _ret7 = (_temp7 = (_this7 = _possibleConstructorReturn(this, (_ref7 = DataTableCell.__proto__ || Object.getPrototypeOf(DataTableCell)).call.apply(_ref7, [this].concat(args))), _this7), Object.defineProperty(_this7, 'tag', {
      enumerable: true,
      writable: true,
      value: 'td'
    }), Object.defineProperty(_this7, 'classNames', {
      enumerable: true,
      writable: true,
      value: function value(props) {
        return ['rmwc-data-table__cell', {
          'rmwc-data-table__cell--align-start': props.alignStart,
          'rmwc-data-table__cell--align-middle': props.alignMiddle,
          'rmwc-data-table__cell--align-end': props.alignEnd
        }];
      }
    }), Object.defineProperty(_this7, 'consumeProps', {
      enumerable: true,
      writable: true,
      value: ['alignStart', 'alignMiddle', 'alignEnd']
    }), _temp7), _possibleConstructorReturn(_this7, _ret7);
  }

  return DataTableCell;
}(_base.Component);

Object.defineProperty(DataTableCell, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'DataTableCell'
});
/** A simple data table to render matrices. */

var SimpleDataTable = exports.SimpleDataTable = function (_React$Component) {
  _inherits(SimpleDataTable, _React$Component);

  function SimpleDataTable() {
    _classCallCheck(this, SimpleDataTable);

    return _possibleConstructorReturn(this, (SimpleDataTable.__proto__ || Object.getPrototypeOf(SimpleDataTable)).apply(this, arguments));
  }

  _createClass(SimpleDataTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          _props$getRowProps = _props.getRowProps,
          getRowProps = _props$getRowProps === undefined ? function (row, index, isHead) {
        return {};
      } : _props$getRowProps,
          _props$getCellProps = _props.getCellProps,
          getCellProps = _props$getCellProps === undefined ? function (row, index, isHead) {
        return {};
      } : _props$getCellProps,
          rest = _objectWithoutProperties(_props, ['data', 'headers', 'getRowProps', 'getCellProps']);

      return React.createElement(DataTable, rest, React.createElement(DataTableContent, null, !!headers && React.createElement(DataTableHead, null, headers.map(function (row, i) {
        return React.createElement(DataTableRow, Object.assign({
          key: i
        }, getRowProps(row, i, true)), row.map(function (cell, j) {
          return React.createElement(DataTableHeadCell, Object.assign({
            key: j
          }, getCellProps(cell, j, true)), cell);
        }));
      })), React.createElement(DataTableBody, null, data.map(function (row, i) {
        return React.createElement(DataTableRow, Object.assign({
          key: i
        }, getRowProps(row, i, false)), row.map(function (cell, j) {
          return React.createElement(DataTableCell, Object.assign({
            key: j
          }, getCellProps(cell, j, false)), cell);
        }));
      }))));
    }
  }]);

  return SimpleDataTable;
}(React.Component);